export default __webpack_public_path__ + "static/media/support.30105626.svg";